import { AppInitializer } from "./AppInitializer";
import { AppProviders } from "./providers";
import { AppRouting } from "./routing";

export const App = () => {
  return (
    <AppProviders>
      <AppInitializer>
        <AppRouting />
      </AppInitializer>
    </AppProviders>
  );
};
